import './waves.css'

const context = '@@wavesContext'

function handleClick(el, binding) {
  const { value } = binding
  const modifiers = binding.modifiers || {}
  const element = el
  if (!element || element.getAttribute('disabled') !== null) return

  const position = modifiers.center ? 'center' : 'position'
  const rect = element.getBoundingClientRect()
  const width = rect.width
  const height = rect.height
  const offset = {
    top: rect.top,
    left: rect.left
  }
  const ripple = document.createElement('span')
  const rippleContainer = document.createElement('div')

  // 设置波纹容器样式
  rippleContainer.className = 'waves-ripple-container'
  Object.assign(rippleContainer.style, {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    borderRadius: 'inherit',
    pointerEvents: 'none'
  })

  let clientX = 0
  let clientY = 0

  // 获取点击位置
  if (position === 'center') {
    clientX = width / 2
    clientY = height / 2
  } else {
    clientX = (event.clientX || event.touches[0].clientX) - offset.left
    clientY = (event.clientY || event.touches[0].clientY) - offset.top
  }

  // 设置波纹样式
  const rippleColor = value || 'rgba(0, 0, 0, 0.15)'
  ripple.className = 'waves-ripple'
  ripple.style.cssText = `
    position: absolute;
    left: ${clientX - width}px;
    top: ${clientY - height}px;
    width: ${width * 2}px;
    height: ${height * 2}px;
    margin-top: 0;
    margin-left: 0;
    background-color: ${rippleColor};
    border-radius: 50%;
    transform: scale(0);
    transition: transform 0.6s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.6s cubic-bezier(0.23, 1, 0.32, 1);
    pointer-events: none;
    opacity: 0.4;
  `

  // 添加波纹到容器
  rippleContainer.appendChild(ripple)
  element.appendChild(rippleContainer)

  // 触发波纹动画
  setTimeout(() => {
    ripple.style.transform = 'scale(1)'
    ripple.style.opacity = '0'
  }, 0)

  // 动画结束后移除波纹
  setTimeout(() => {
    try {
      element.removeChild(rippleContainer)
    } catch (error) {
      // 忽略可能的错误
    }
  }, 600)
}

export default {
  mounted(el, binding) {
    el[context] = {
      removeHandle: null
    }
    const handle = (e) => handleClick(el, binding, e)
    el[context].removeHandle = handle
    el.addEventListener('click', handle)
  },
  unmounted(el) {
    if (el[context] && el[context].removeHandle) {
      el.removeEventListener('click', el[context].removeHandle)
      el[context] = null
      delete el[context]
    }
  }
} 